import React from 'react';
import { Spin } from 'antd';
// import { Link } from 'react-router-dom';
import { useCollection } from 'react-firebase-hooks/firestore';
// import { ROUTE_WORKER_PREFIX as ROUTE_PREFIX } from 'utils/routes';

import Client from 'containers/app/client';
import RequestCard from 'containers/worker/pages/booking-requests/request-card';

import './style.css';

const BookingsPedingWidget = () => {
  const bookingRef = Client.db
    .collection('booking_request')
    .where('worker', '==', Client.currentUserId());
  const [collection, loading, error] = useCollection(bookingRef);

  if (loading) return <Spin />;
  if (error) throw new Error(error);

  const pendingRequests = collection.docs.filter((doc) => {
    const { status } = doc.data();
    return status === 'pending';
  });

  const count = pendingRequests.length;
  if (count < 1) return null;

  // const first = pendingRequests[0].data();

  // if (count === 1)
  //   return <RequestCard id={pendingRequests[0].id} request={first} />;

  // return (
  //   <Card
  //     title="Pending Requests"
  //     extra={<Link to={`${ROUTE_PREFIX}/booking-requests`}>More</Link>}
  //   >
  //     <h2>You have {count} pending requests</h2>
  //   </Card>
  // );

  return (
    <>
      {pendingRequests.map((doc) => (
        <RequestCard id={doc.id} request={doc.data()} />
      ))}
    </>
  );
};

export default BookingsPedingWidget;
